import { render, staticRenderFns } from "./bookingConfirmPage.vue?vue&type=template&id=af9b5e28&scoped=true&"
import script from "./bookingConfirmPage.vue?vue&type=script&lang=ts&"
export * from "./bookingConfirmPage.vue?vue&type=script&lang=ts&"
import style0 from "./bookingConfirmPage.vue?vue&type=style&index=0&id=af9b5e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b5e28",
  null
  
)

export default component.exports